import type { GetAccountsListItem } from "@birdwatch/client";

import AccountItemDisplay from "@/components/ui/account-item-display";
import Avatar from "@/components/ui/avatar/avatar";

import type { FilterOption } from "../types";

/**
 * Account → `FilterOption` mapper for the declarative entity filters. The chip
 * pill is a name-initials avatar (colored by name; the list item carries no
 * image URL); the option-row body is an avatar + name + email — matching the
 * legacy account picker. `label` stays the short text for the chip + count.
 * Shared by every account picker (admin users/subscriptions/purchase-intents)
 * so they render identically. A name-only fallback is what made the rows drift
 * from the legacy pickers (QA #3).
 */
export function toAccountFilterOption(
  account: GetAccountsListItem,
): FilterOption {
  return {
    value: account.id,
    label: account.name || account.email || account.id,
    pill: (
      <Avatar src="" name={account.name ?? ""} size="xs" className="shrink-0" />
    ),
    detail: (
      <AccountItemDisplay
        account={account}
        size="sm"
        className="pointer-events-none"
      />
    ),
  };
}
